import vars from '../globals';
import {initParallax, destroyParallax} from '../components/parallax';

const $leafs = $('.leaf');
const $activeLeafs = $('.leaf.isActive');

let parallaxState = false;
// let resizeTimeout = null;

const setActiveLeaf = () => {
	$leafs.each((i, leaf) => {
		let $leaf = $(leaf);
		// let leafRotation = $leaf.data('rotation');
		let leafTop = $leaf.offset().top;
		let leafHeight = $leaf.height();

		let scrollTop = window.pageYOffset;
		let scrollTopHeight = scrollTop + window.innerHeight;

		if (scrollTopHeight >= leafTop && leafTop + leafHeight >= scrollTop && leafTop !== 0) {
			if (!$leaf.hasClass('isActive') && !$leaf.hasClass('isHidden')) {
				$leaf.addClass('isActive');

				setTimeout(() => {
					initParallax($leaf);
					parallaxState = true;
				}, 2000);
			}

			// TweenMax.killTweensOf($leafs);
			// TweenMax.set($leafs, {clearProps: 'all'});

			// if (!$leaf.hasClass('isActive')) {
			// 	new TimelineMax({
			// 		onStart() {

			// 		},
			// 		onComplete() {
			// 			$leaf.addClass('isActive');
			// 		},
			// 	})
			// 		.from($leaf, 2, {
			// 			rotation: leafRotation,
			// 			clearProps: 'all',
			// 		});
			// }
		}
	});
};

// window.addEventListener('resize', () => {
// 	if (resizeTimeout) {
// 		clearTimeout(resizeTimeout);
// 	}

// 	resizeTimeout = setTimeout(() => {
// 		if (!vars.isMobile() && !parallaxState) {
// 			initParallax(parallaxItemList);
// 		} else if (vars.isMobile() && parallaxState) {
// 			destroyParallax(parallaxItemList);
// 		}
// 	}, 500);
// });

// initParallax($leaf);
// parallaxState = true;

$(window).on('resize scroll', () => {
	if (vars.isMobile()) {
		if (parallaxState) {
			destroyParallax($activeLeafs);
			parallaxState = false;
		}
	} else {
		setActiveLeaf();

		if (!parallaxState) {
			initParallax($activeLeafs);
			parallaxState = true;
		}
	}
});

const leafsInit = () => {
	if (vars.isMobile()) {
		return;
	}

	$leafs.each((i, leaf) => {
		let $leaf = $(leaf);

		$leaf.removeClass('isHidden');
	});

	setActiveLeaf();
};

const leafsDestroy = () => {
	destroyParallax($activeLeafs);
	parallaxState = false;

	$leafs.each((i, leaf) => {
		let $leaf = $(leaf);

		$leaf.removeClass('isActive');
		$leaf.addClass('isHidden');
		$leaf.attr('style', '');
	});
};

export {leafsInit, leafsDestroy};
